import * as actions from 'client/store/actions';
import * as getters from 'client/store/getters';
import * as mutations from 'client/store/mutations';
import { CommandTemplatesConsts, ItemTypeConsts, PolicyConsts } from 'client/util/Constants';
import { createCommandCustomTemplateCollectionClass } from 'client/store/modules/collections/CommandCustomTemplateCollection';
import { createCommandTemplateCollectionClass } from 'client/store/modules/collections/CommandTemplateCollection';
import { createEventsModule } from 'client/store/modules/InsightsEventModule';
import { createPolicyCollection } from 'client/store/modules/collections/PolicyCollection';
import { createPolicyTemplateCollectionClass } from 'client/store/modules/collections/PolicyTemplateCollection';
import { createSystemCollection } from 'client/store/modules/collections/SystemCollection';
import ALaCarteComponentCollection from 'client/store/modules/collections/ALaCarteComponentCollection';
import AccountManagerCalendarModule from 'client/store/modules/AccountManagerCalendarModule';
import ActiveDirectoryModel from 'client/store/modules/models/ActiveDirectoryModel';
import AdBridgeAgentCollection from 'client/store/modules/collections/AdBridgeAgentCollection';
import AddOnCollection from 'client/store/modules/collections/AddOnCollection';
import AdministratorModel from 'client/store/modules/models/AdministratorModel';
import AlertModule from 'client/store/modules/AlertModule';
import AppAuthorizationCollection from 'client/store/modules/collections/AppAuthorizationCollection';
import AppAuthorizationModel from 'client/store/modules/models/AppAuthorizationModel';
import ApplicationCollection from 'client/store/modules/collections/ApplicationCollection';
import ApplicationModel from 'client/store/modules/models/ApplicationModel';
import ApplicationTemplateCollection from 'client/store/modules/collections/ApplicationTemplateCollection';
import AsidePanelEventsModule from 'client/store/modules/AsidePanelEventsModule';
import AuthNPoliciesCollection from 'client/store/modules/collections/AuthNPoliciesCollection';
import AuthNPolicyModel from 'client/store/modules/models/AuthNPolicyModel';
import BetterValuePackageModule from 'client/store/modules/BetterValuePackageModule';
import ChatModule from 'client/store/modules/ChatModule';
import CheckoutModel from 'client/store/modules/models/CheckoutModel';
import CloudInsightsAccountsCollection from 'client/store/modules/collections/CloudInsightsAccountsCollection';
import CloudInsightsEventsCollection from 'client/store/modules/collections/CloudInsightsEventsCollection';
import CommandModel from 'client/store/modules/models/CommandModel';
import CommandQueueCollection from 'client/store/modules/collections/CommandQueueCollection';
import CommandQueueWorkflowCollection from 'client/store/modules/collections/CommandQueueWorkflowCollection';
import CommandResultsCollection from 'client/store/modules/collections/CommandResultsCollection';
import CommandRunnerCollection from 'client/store/modules/collections/CommandRunnerCollection';
import CommandTemplateModel from 'client/store/modules/models/CommandTemplateModel';
import CommandsCollection from 'client/store/modules/collections/CommandsCollection';
import ConfigurationGroupCollection from 'client/store/modules/collections/ConfigurationGroupCollection';
import ConfigurationGroupModel from 'client/store/modules/models/ConfigurationGroupModel';
import ConfigurationModel from 'client/store/modules/models/ConfigurationModel';
import CustomEmailModel from 'client/store/modules/models/CustomEmailModel';
import CustomPolicyGroupTemplateCollection from 'client/store/modules/collections/CustomPolicyGroupTemplateCollection';
import DefaultPolicyGroupTemplateCollection from 'client/store/modules/collections/DefaultPolicyGroupTemplateCollection';
import DeviceAppStatusCollection from 'client/store/modules/collections/DeviceAppStatusCollection';
import DirectoryCollection from 'client/store/modules/collections/DirectoryCollection';
import DirectoryGroupingModule from 'client/store/modules/DirectoryGroupingModule';
import DirectoryImportCollection from 'client/store/modules/collections/DirectoryImportCollection';
import DuoSettingsModule from 'client/store/modules/DuoSettingsModule';
import FeatureFlagsModule from 'client/store/modules/FeatureFlagsModule';
import FeatureTrialModule from 'client/store/modules/FeatureTrialModule';
import GSuiteDirectoryModel from 'client/store/modules/models/GSuiteDirectoryModel';
import GSuiteImportCollection from 'client/store/modules/collections/GSuiteImportCollection';
import GeolocationCollection from 'client/store/modules/collections/GeolocationCollection';
import GeolocationModel from 'client/store/modules/models/GeolocationModel';
import GoogleModule from 'client/store/modules/GoogleModule';
import GroupCollection from 'client/store/modules/collections/GroupCollection';
import GrowthModule from 'client/store/modules/GrowthModule';
import GuidedSetupModule from 'client/store/modules/guidedSetup/GuidedSetupModule';
import ImportUsersCollection from 'client/store/modules/collections/ImportUsersCollection';
import IpListModel from 'client/store/modules/models/IpListModel';
import IpListsCollection from 'client/store/modules/collections/IpListsCollection';
import KnowledgeModule from 'client/store/modules/KnowledgeModule';
import LdapAccessPolicyModel from 'client/store/modules/models/LdapAccessPolicyModel';
import LdapModel from 'client/store/modules/models/LdapModel';
import MdmSettingsModel from 'client/store/modules/models/MdmSettingsModel';
import NotificationsCollection from 'client/store/modules/collections/NotificationsCollection';
import O365DirectoryModel from 'client/store/modules/models/O365DirectoryModel';
import O365ImportCollection from 'client/store/modules/collections/O365ImportCollection';
import OauthProviderManagementModule from 'client/store/modules/OauthProviderManagementModule';
import OnboardingModule from 'client/store/modules/OnboardingModule';
import OrganizationInvoiceCollection from 'client/store/modules/collections/OrganizationInvoiceCollection';
import OrganizationModel from 'client/store/modules/models/OrganizationModel';
import OrganizationsCollection from 'client/store/modules/collections/OrganizationsCollection';
import OsDistributionModule from 'client/store/modules/OsDistributionModule';
import OsReleasesPatchesModule from 'client/store/modules/OsReleasesPatchesModule';
import PartnersModule from 'client/store/modules/PartnersModule';
import PasswordManagerAppVersionCollection from 'client/store/modules/collections/PasswordManagerAppVersionCollection';
import PasswordManagerItemCollection from 'client/store/modules/collections/PasswordManagerItemCollection';
import PasswordManagerModule from 'client/store/modules/PasswordManagerModule';
import PasswordManagerUserCollection from 'client/store/modules/collections/PasswordManagerUserCollection';
import PasswordManagerUserModel from 'client/store/modules/models/PasswordManagerUserModel';
import PaymentModel from 'client/store/modules/models/PaymentModel';
import PkiModule from 'client/store/modules/PkiModule';
import PlanModule from 'client/store/modules/PlanModule';
import PolicySystemStatusCollection from 'client/store/modules/collections/PolicySystemStatusCollection';
import PricingCalculatorModule from 'client/store/modules/PricingCalculatorModule';
import PricingModule from 'client/store/modules/PricingModule';
import ProgressModule from 'client/store/modules/ProgressModule';
import ProvidersCollection from 'client/store/modules/collections/ProvidersCollection';
import PushMfaConfigModule from 'client/store/modules/push/PushMfaConfigModule';
import PushMfaModule from 'client/store/modules/push/PushMfaModule';
import PushMfaUserEndpointsModule from 'client/store/modules/push/PushMfaUserEndpointsModule';
import PushMfaUserPortalModule from 'client/store/modules/push/PushMfaUserPortalModule';
import RadiusServerCollection from 'client/store/modules/collections/RadiusServerCollection';
import RadiusServerModel from 'client/store/modules/models/RadiusServerModel';
import RecommendationModule from 'client/store/modules/RecommendationModule';
import ReportsCollection from 'client/store/modules/collections/ReportsCollection';
import SambaModel from 'client/store/modules/models/SambaModel';
import ScimUsersImportCollection from 'client/store/modules/collections/ScimUsersImportCollection';
import SettingsModel from 'client/store/modules/models/SettingsModel';
import SettingsModule from 'client/store/modules/SettingsModule';
import SharedFolderCollection from 'client/store/modules/collections/SharedFolderCollection';
import SharedFolderGroupCollection from 'client/store/modules/collections/SharedFolderGroupCollection';
import SharedFolderModel from 'client/store/modules/models/SharedFolderModel';
import SharedFolderSystemUserCollection from 'client/store/modules/collections/SharedFolderSystemUserCollection';
import SoftwareAppsCollection from 'client/store/modules/collections/SoftwareAppsCollection';
import SoftwareAppsModel from 'client/store/modules/models/SoftwareAppsModel';
import SoftwareAppsStatusCollection from 'client/store/modules/collections/SoftwareAppsStatusCollection';
import SsoApplicationAccessPolicyModel from 'client/store/modules/models/SsoApplicationAccessPolicyModel';
import SubscriptionCollection from 'client/store/modules/collections/SubscriptionCollection';
import SuggestedSystemUsersCollection from 'client/store/modules/collections/SuggestedSystemUsersCollection';
import SupportCaseCollection from 'client/store/modules/collections/SupportCaseCollection';
import SupportModule from 'client/store/modules/SupportModule';
import SystemGroupCollection from 'client/store/modules/collections/SystemGroupCollection';
import SystemGroupModel from 'client/store/modules/models/SystemGroupModel';
import SystemInsightsModule from 'client/store/modules/SystemInsightsModule';
import SystemModel from 'client/store/modules/models/SystemModel';
import SystemPolicyStatusCollection from 'client/store/modules/collections/SystemPolicyStatusCollection';
import SystemUserCollection from 'client/store/modules/collections/SystemUserCollection';
import SystemUserModel from 'client/store/modules/models/SystemUserModel';
import SystemUserWebAuthnKeysModel from 'client/store/modules/models/SystemUserWebAuthnKeysModel';
import TotpSettingsModule from 'client/store/modules/TotpSettingsModule';
import TrialRecapModule from 'client/store/modules/TrialRecapModule';
import UserCollection from 'client/store/modules/collections/UserCollection';
import UserDisplayPreferencesModule from 'client/store/modules/UserDisplayPreferencesModule';
import UserGroupCollection from 'client/store/modules/collections/UserGroupCollection';
import UserGroupModel from 'client/store/modules/models/UserGroupModel';
import UserPortalFallbackPolicyModel from 'client/store/modules/models/UserPortalFallbackPolicyModel';
import VppModule from 'store/modules/VppModule';
import Vue from 'vue';
import Vuex from 'vuex';
import WebAuthnConfigModule from 'client/store/modules/webauthn/WebAuthnConfigModule';
import WebAuthnModule from 'client/store/modules/webauthn/WebAuthnModule';
import WebAuthnUserPortalModule from 'client/store/modules/webauthn/WebAuthnUserPortalModule';
import WorkdayImportedUserCollection from 'client/store/modules/collections/WorkdayImportedUserCollection';
import WorkdayModel from 'client/store/modules/models/WorkdayModel';
import WorkdayWorkerCollection from 'client/store/modules/collections/WorkdayWorkerCollection';

const { policyTemplateTypes } = PolicyConsts;
const InsightsEventModule = createEventsModule();
const MdmEventsModule = createEventsModule();
const PolicyTemplateCollection = createPolicyTemplateCollectionClass();
const PolicyTemplateAndroidCollection = createPolicyTemplateCollectionClass(
  policyTemplateTypes.android,
);
const PolicyTemplateLinuxCollection = createPolicyTemplateCollectionClass(
  policyTemplateTypes.linux,
);
const PolicyTemplateMacCollection = createPolicyTemplateCollectionClass(policyTemplateTypes.mac);
const PolicyTemplateIosCollection = createPolicyTemplateCollectionClass(policyTemplateTypes.ios);
const PolicyTemplateWindowsCollection = createPolicyTemplateCollectionClass(
  policyTemplateTypes.windows,
);

const { types: osTypes } = CommandTemplatesConsts;
const CommandTemplateCollection = createCommandTemplateCollectionClass();
const CommandCustomTemplateCollection = createCommandCustomTemplateCollectionClass();
const CommandTemplateLinuxCollection = createCommandTemplateCollectionClass(osTypes.linux);
const CommandTemplateMacOsCollection = createCommandTemplateCollectionClass(osTypes.mac);
const CommandTemplateWindowsCollection = createCommandTemplateCollectionClass(osTypes.windows);

const SystemCollection = createSystemCollection();
const SystemUnacknowledgedCollection = createSystemCollection(ItemTypeConsts.systemUnacknowledged);
const SystemNeedsAttentionCollection = createSystemCollection(ItemTypeConsts.systemNeedsAttention);

const PolicyCollection = createPolicyCollection(ItemTypeConsts.policy);
const BpmPolicyCollection = createPolicyCollection(ItemTypeConsts.browserPatchManagement);
const OspPolicyCollection = createPolicyCollection(ItemTypeConsts.osPatchManagement);

Vue.use(Vuex);

export default new Vuex.Store({
  strict: process.env.NODE_ENV.indexOf('dev') >= 0,
  state: {},
  modules: {
    ALaCarteComponentCollection,
    AccountManagerCalendarModule,
    ActiveDirectoryModel,
    AdBridgeAgentCollection,
    AddOnCollection,
    AdministratorModel,
    AlertModule,
    AppAuthorizationCollection,
    AppAuthorizationModel,
    ApplicationCollection,
    ApplicationModel,
    ApplicationTemplateCollection,
    AsidePanelEventsModule,
    AuthNPoliciesCollection,
    AuthNPolicyModel,
    BetterValuePackageModule,
    BpmPolicyCollection,
    ChatModule,
    CheckoutModel,
    CloudInsightsAccountsCollection,
    CloudInsightsEventsCollection,
    CommandCustomTemplateCollection,
    CommandModel,
    CommandQueueCollection,
    CommandQueueWorkflowCollection,
    CommandResultsCollection,
    CommandRunnerCollection,
    CommandTemplateCollection,
    CommandTemplateLinuxCollection,
    CommandTemplateMacOsCollection,
    CommandTemplateModel,
    CommandTemplateWindowsCollection,
    CommandsCollection,
    ConfigurationGroupCollection,
    ConfigurationGroupModel,
    ConfigurationModel,
    CustomEmailModel,
    CustomPolicyGroupTemplateCollection,
    DefaultPolicyGroupTemplateCollection,
    DeviceAppStatusCollection,
    DirectoryCollection,
    DirectoryGroupingModule,
    DirectoryImportCollection,
    DuoSettingsModule,
    FeatureFlagsModule,
    FeatureTrialModule,
    GSuiteDirectoryModel,
    GSuiteImportCollection,
    GeolocationCollection,
    GeolocationModel,
    GoogleModule,
    GroupCollection,
    GrowthModule,
    GuidedSetupModule,
    ImportUsersCollection,
    InsightsEventModule,
    IpListModel,
    IpListsCollection,
    KnowledgeModule,
    LdapAccessPolicyModel,
    LdapModel,
    MdmEventsModule,
    MdmSettingsModel,
    NotificationsCollection,
    O365DirectoryModel,
    O365ImportCollection,
    OauthProviderManagementModule,
    OnboardingModule,
    OrganizationInvoiceCollection,
    OrganizationModel,
    OrganizationsCollection,
    OsDistributionModule,
    OsReleasesPatchesModule,
    OspPolicyCollection,
    PartnersModule,
    PasswordManagerAppVersionCollection,
    PasswordManagerItemCollection,
    PasswordManagerModule,
    PasswordManagerUserCollection,
    PasswordManagerUserModel,
    PaymentModel,
    PkiModule,
    PlanModule,
    PolicyCollection,
    PolicySystemStatusCollection,
    PolicyTemplateCollection,
    PolicyTemplateAndroidCollection,
    PolicyTemplateIosCollection,
    PolicyTemplateLinuxCollection,
    PolicyTemplateMacCollection,
    PolicyTemplateWindowsCollection,
    PricingCalculatorModule,
    PricingModule,
    ProgressModule,
    ProvidersCollection,
    PushMfaConfigModule,
    PushMfaModule,
    PushMfaUserEndpointsModule,
    PushMfaUserPortalModule,
    RadiusServerCollection,
    RadiusServerModel,
    RecommendationModule,
    ReportsCollection,
    SambaModel,
    ScimUsersImportCollection,
    SettingsModel,
    SettingsModule,
    SharedFolderCollection,
    SharedFolderGroupCollection,
    SharedFolderModel,
    SharedFolderSystemUserCollection,
    SoftwareAppsCollection,
    SoftwareAppsModel,
    SoftwareAppsStatusCollection,
    SsoApplicationAccessPolicyModel,
    SubscriptionCollection,
    SuggestedSystemUsersCollection,
    SupportCaseCollection,
    SupportModule,
    SystemCollection,
    SystemGroupCollection,
    SystemGroupModel,
    SystemInsightsModule,
    SystemModel,
    SystemNeedsAttentionCollection,
    SystemPolicyStatusCollection,
    SystemUnacknowledgedCollection,
    SystemUserCollection,
    SystemUserModel,
    SystemUserWebAuthnKeysModel,
    TotpSettingsModule,
    TrialRecapModule,
    UserCollection,
    UserDisplayPreferencesModule,
    UserGroupCollection,
    UserGroupModel,
    UserPortalFallbackPolicyModel,
    VppModule,
    WebAuthnConfigModule,
    WebAuthnModule,
    WebAuthnUserPortalModule,
    WorkdayImportedUserCollection,
    WorkdayModel,
    WorkdayWorkerCollection,
  },
  getters,
  actions,
  mutations,
});
